<!-- 树形选择器 -->
<template>
  <el-select ref="select" :size="size" :value="valueId" :clearable="clearable" @clear="clearHandle" :placeholder="placeholder"
    @click.native="selectClick" filterable :filter-method="filterFunc">
    <!-- <el-input class="selectInput" :placeholder="placeholder" v-model="filterText"></el-input> -->
    <el-option class="m-scroll" :value="valueId" :label="valueTitle">
      <el-tree id="tree-option" ref="treeSelect" :accordion="accordion" :data="options" :props="props" :node-key="props.value"
        :default-expanded-keys="defaultExpandedKey" :filter-node-method="filterNode" @current-change="handleChange"></el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "tree-select",
  props: {
    /* 配置项 */
    props: {
      type: Object,
      default: () => {
        return {
          value: "id", // ID字段名
          label: "title", // 显示名称
          children: "children", // 子级字段名
        };
      },
    },
    /* 选项列表数据(树形结构的对象数组) */
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /* 初始值 */
    value: {
      type: Number,
      default: () => {
        return null;
      },
    },
    /* 可清空选项 */
    clearable: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    /* 自动收起 */
    accordion: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    placeholder: {
      type: String,
      default: () => {
        return "请选择";
      },
    },
    size: {
      type: String,
      default: "mini",
    },
    parentSelect: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    isSelectClick: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filterText: "",
      valueId: this.value, // 初始值
      valueTitle: "",
      defaultExpandedKey: [],
      initSelect: false,
      timer: null,
    };
  },
  mounted() {
    this.initScroll();
    console.log(this.value,"this.value");
  },
  watch: {
    value() {
      this.valueId = this.value;
      this.initScroll();
    },
    filterText(val) {
      this.$refs.treeSelect.filter(val);
    },
  },
  methods: {
    setData() {
      this.$nextTick(() => {
        this.valueId = this.value;

        if (this.valueId) {
          // console.log("setData", this.$refs.treeSelect.getNode(this.valueId));
          let node = this.$refs.treeSelect.getNode(this.valueId);
          console.log(node,"aa");
          if (node) {
            console.log(this.props.label,"label");
            this.valueTitle = node.data[this.props.label]; // 初始化显示
            console.log(this.valueTitle,"valueTitle");
            this.$refs.treeSelect.setCurrentKey(this.valueId); // 设置默认选中
            this.defaultExpandedKey = [this.valueId]; // 设置默认展开
            this.$emit("node-select", node);
            this.handleChange(node.data, node)
          }
        }else{
          this.valueTitle="";
        }
      });
    },
    selectClick() {
      if (this.isSelectClick && !this.initSelect) {
        this.setData()
        this.initSelect = true;
        if (this.timer) {
          clearTimeout(this.timer)
        }

        this.$nextTick(() => {
          this.$refs.select.blur()
          this.timer = setTimeout(() => {
            this.$refs.select.visible = true;
          }, 500)
        })
      }
    },
    // 初始化滚动条
    initScroll() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          ".el-scrollbar .el-select-dropdown__wrap"
        )[0];
        let scrollBar = document.querySelectorAll(
          ".el-scrollbar .el-scrollbar__bar"
        );
        scrollWrap.style.cssText =
          "margin: 0px; max-height: none; overflow: hidden;";
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
      if (this.label) {
        this.valueTitle = this.label;
      }
    },
    // 切换选项
    handleChange(node, self) {
      if (this.parentSelect) {
        this.valueTitle = node[this.props.label];
        this.valueId = node[this.props.value];
        this.$emit("node-select", node);
        this.defaultExpandedKey = [];
        this.$refs.select.blur();
      } else {
        if (node.children != undefined) {
          self.isCurrent = false;
          this.$refs.treeSelect.setCurrentKey(this.valueId);
        } else {
          this.valueTitle = node[this.props.label];
          this.valueId = node[this.props.value];
          this.$emit("node-select", node);
          this.defaultExpandedKey = [];
          this.$refs.select.blur();
        }
      }
      this.$refs.treeSelect.filter("");
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = "";
      this.valueId = null;
      this.defaultExpandedKey = [];
      this.clearTreeSelected();
      // this.clearSelected();
      this.$emit("node-select", null);
      this.$emit("clear");
    },
    // /* 清空选中样式 */
    // clearSelected() {
    //   let allNode = document.querySelectorAll("#tree-option .el-tree-node");
    //   allNode.forEach((element) => element.classList.remove("is-current"));
    // },
    filterNode(value, data) {
      if (!value) return true;
      return data[this.props.label].indexOf(value) !== -1;
    },
    filterFunc(val) {
      this.$refs.treeSelect.filter(val);
      return true;
    },
    clearTreeSelected() {
      this.$refs.treeSelect.filter("");
      this.$refs.treeSelect.setCurrentKey(null);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 245px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
</style>